import {
  BCA_VA,
  BJB_VA,
  BNI_VA,
  BRI_VA,
  BSI_VA,
  BSS_VA,
  CIMB_VA,
  MANDIRI_VA,
  PERMATA_VA
} from 'assets'
export const labelAccountNumberByAccountType = {
  COMPANY: 'NPWP',
  PERSONAL: 'NIK'
}
export const CONST_EVENT = 'EVENT'
export const CONST_SPONSORSHIP = 'SPONSORSHIP'
export const CONST_VALUATION_TOOLS = 'VALUATION_TOOL'
export const CONST_EXTRA_BUNDLE = 'EXTRA_BUNDLE'
export const ftesValue = [
  { label: '1-10', value: '1' },
  { label: '11-50', value: '2' },
  { label: '51-100', value: '3' },
  { label: '100+', value: '4' }
]

export const turnOverOptions = [
  { value: 'low_to_high', label: 'Omset: Rendah ke Tinggi' },
  { value: 'high_to_low', label: 'Omset: Tinggi ke Rendah' }
]

export const typeUserConst = {
  UNDECIDED: 'UNDECIDED',
  FREE: 'FREE',
  PAID: 'PAID'
}
export const entryFeeValue = [
  { label: 'Di bawah Rp50 juta', value: '1' },
  { label: 'Rp50 juta - Rp100 juta', value: '2' },
  { label: 'Rp100 juta - Rp250 juta', value: '3' },
  { label: 'Rp250 juta - Rp500 juta', value: '4' },
  { label: 'Rp500 juta - Rp1 miliar', value: '5' },
  { label: 'Di atas Rp1 miliar', value: '6' }
]

export const legalStatusOptions = [
  { label: 'Kepemilikan Tunggal', value: 'sole-proprietorship' },
  { label: 'Firma (Fa)', value: 'partnership-fa' },
  { label: 'Persekutuan Komanditer (CV)', value: 'limited-partnership-cv' },
  { label: 'Perseroan Terbatas (PT)', value: 'limited-liability-company-pt' },
  { label: 'Perusahaan Perseroan (Persero)', value: 'state-owned-company-persero' },
  { label: 'Perusahaan Umum (Perum)', value: 'public-corporation-perum' }
]

export const customerTypeOptions = [
  { label: 'B2C', value: 'b2c' },
  { label: 'B2B', value: 'b2b' },
  { label: 'B2C & B2B', value: 'b2c-b2b' }
]

export const acquisitionTypeOptions = [
  { label: 'Pengambilalihan Penuh', value: 'full-acquisition' },
  { label: 'Pengambilalihan Sebagian', value: 'partial-acquisition' },
  { label: 'Partisipasi / Investasi', value: 'participation-investment' },
  { label: 'Waralaba', value: 'franchise' },
  { label: 'Perputaran', value: 'turnaround' },
  { label: 'Mulai Ulang', value: 'restart' }
]

export const profitExpressionOptions = [
  { label: 'Tidak Ditentukan', value: 'not-specified' },
  { label: 'EBITDA', value: 'ebitda' },
  { label: 'EBIT', value: 'ebit' },
  { label: 'Untung Bersih', value: 'net-profit' }
]

export const buyerPreferencesOptions = [
  { label: 'Pembeli Strategis', value: 'strategic-buyer' },
  { label: 'MBI (Management-Buy-In)', value: 'mbi-management-buy-in' },
  { label: 'Investor', value: 'investor' }
]

export const reasonForSaleOptions = [
  { label: 'Usia pengusaha saat ini', value: 'current-entrepreneur-age' },
  {
    label: 'Pengusaha saat ini ingin fokus pada kegiatan lain',
    value: 'entrepreneur-wants-to-focus-on-other-activities'
  },
  {
    label: 'Fase pertumbuhan berikutnya membutuhkan tipe wirausaha yang berbeda',
    value: 'next-growth-phase-requires-different-entrepreneur-type'
  },
  {
    label: 'Menarik modal untuk pertumbuhan lebih lanjut',
    value: 'raise-capital-for-further-growth'
  },
  { label: 'Menarik mitra strategis', value: 'attract-strategic-partner' },
  { label: 'Keadaan pribadi', value: 'personal-reasons' }
]
export const operationPhaseCompanyOptions = [
  {
    label: 'Perusahaan Mapan',
    value: 'established-company'
  },
  {
    label: 'Perusahaan Bertumbuh',
    value: 'growing-company'
  },
  {
    label: 'Startup (< 1 tahun)',
    value: 'startup'
  },
  {
    label: 'Ide Bisnis',
    value: 'business-idea'
  },
  {
    label: 'Perusahaan dalam Penurunan',
    value: 'declining-company'
  },
  {
    label: 'Lainnya',
    value: 'others'
  }
]

export const operationPhaseValue = [
  {
    label: 'Perusahaan Sudah Berdiri',
    value: 'established-business',
    category: ['buyer', 'investor']
  },
  {
    label: 'Perusahaan Berkembang',
    value: 'growing-business',
    category: ['buyer', 'franchise']
  },
  // { label: 'Usaha Kecil', value: 'usaha-kecil', category: ['buyer', 'franchise'] },
  { label: 'Startup (< 1 tahun)', value: 'startup', category: ['buyer', 'investor'] },
  { label: 'Ide Bisnis', value: 'business-idea', category: ['buyer', 'franchise'] },
  {
    label: 'Perusahaan sedang Menurun',
    value: 'declining-business',
    category: ['buyer', 'investor']
  },
  {
    label: 'Lainnya',
    value: 'others',
    category: ['buyer', 'investor']
  }
]

export const mergedOperationPhaseOptions = [...operationPhaseCompanyOptions, ...operationPhaseValue]

export const sectorsValue = [
   { label: 'Agribisnis & Pangan', value: 'agribisnis-and-food' },
   { label: 'Food & Beverage (F&B)', value: 'food-and-beverage' },
   { label: 'Fast-Moving Consumer Goods (FMCG)', value: 'fast-moving-consumer-goods' },
   { label: 'Otomotif', value: 'automotive' },
   { label: 'Transportasi & Logistik', value: 'transportation-and-logistics' },
   { label: 'Konstruksi & Teknik Instalasi', value: 'construction-and-installation-engineering' },
   { label: 'Pertanian & Pangan', value: 'agriculture-and-food' },
   { label: 'Properti & Real Estate', value: 'properti-real-estate' },
   { label: 'Energi & Sumber Daya Alam', value: 'energi-and-natural-resources' },
   { label: 'Pertambangan & Migas (Pendukung & Jasa)', value: 'mining-and-oil-and-gas' },
   { label: 'Energi Terbarukan / Green Energy', value: 'green-energy' },
   { label: 'Industri & Manufaktur', value: 'industry-and-manufacturing' },
   { label: 'Tekstil & Garmen', value: 'textiles-and-garments' },
   { label: 'Kimia, Material & Industri Dasar', value: 'chemistry-materials-and-basic-industries' },
   { label: 'Kesehatan & Farmasi', value: 'healthcare-and-pharmaceuticals' },
   { label: 'Pendidikan & Pelatihan', value: 'education-and-training' },
   { label: 'Teknologi Informasi & Software', value: 'information-technology-and-software' }, //duplicate
   { label: 'Telekomunikasi & Infrastruktur Digital', value: 'telecommunications-and-digital-infrastructure' },
   { label: 'Media, Kreatif & Periklanan', value: 'media-creative-and-advertising' },
   { label: 'Keuangan & Jasa Keuangan', value: 'finance-and-financial-services' },
   { label: 'Asuransi & Fintech', value: 'insurance-and-fintech' },
   { label: 'Ritel & Distribusi', value: 'retail-and-distribution' },
   { label: 'Perdagangan Grosir', value: 'wholesale-trade' },
   { label: 'E-commerce & Digital Commerce', value: 'ecommerce-and-digital-commerce' }, //duplicate
   { label: 'Kosmetik & Perawatan Pribadi', value: 'cosmetics-and-personal-care' },
   { label: 'Produk Konsumen & Lifestyle', value: 'consumer-products-and-lifestyle' },
   { label: 'Jasa Profesional & Konsultansi', value: 'professional-services-and-consulting' },
   { label: 'Keamanan & Facility Management', value: 'security-and-facility-management' },
   { label: 'Lingkungan, Pengelolaan Limbah & Daur Ulang', value: 'environment-waste-management-and-recycling' },
   { label: 'Sosial Enterprise & Impact Business', value: 'social-enterprise-and-impact-business' },
   { label: 'Waralaba & Kemitraan Usaha', value: 'franchise-and-business-partnership' },
   { label: 'Perhotelan, Pariwisata & Rekreasi', value: 'hospitality-tourism-and-recreation' },
   { label: 'Event Organizer & MICE', value: 'event-organizer-and-mice' },
   { label: 'Lainnya', value: 'others' },
]

export const totalAdvisorOptions = [
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
  { label: '5', value: '5' }
]

export const turnoverMinValue = [
  { value: '0', label: 'Rp 0' },
  { value: '100000000', label: 'Rp 100.000.000' }
]

export const turnoverMaxValue = [
  { value: '300000', label: 'Rp 300.000.000' },
  { value: 'no-max', label: 'No Maximum' }
]

export const acquisitionTypeValue = [
  { label: 'Pengambilalihan Penuh', value: 'full-acquisition' },
  { label: 'Pengambilalihan Sebagian', value: 'partial-acquisition' },
  { label: 'Partisipasi / Investasi', value: 'participation-investment' },
  { label: 'Waralaba', value: 'franchise' },
  { label: 'Perputaran', value: 'turnaround' },
  { label: 'Mulai Ulang', value: 'restart' }
]

export const offeredInterestRateOptions = [
  { label: 'Tanpa Bunga (0%)', value: 'interest-free-0' },
  { label: 'Bunga Tetap', value: 'fixed-interest' },
  { label: 'Bunga Mengambang (Berdasarkan Pasar)', value: 'floating-interest-market-based' },
  {
    label: 'Bunga Promosi (Diskon Suku Bunga untuk Periode Tertentu)',
    value: 'promotional-interest-rate-discount-for-specific-period'
  },
  {
    label: 'Bunga Bertingkat (Berdasarkan Volume Transaksi)',
    value: 'tiered-interest-based-on-transaction-volume'
  },
  { label: 'Bunga Negosiasi', value: 'negotiated-interest' },
  { label: 'Lainnya', value: 'others' }
]

export const transactionTypeOptions = [
  { label: 'Pembelian Langsung', value: 'direct-purchase' },
  { label: 'Kontrak Jangka Panjang', value: 'long-term-contract' },
  { label: 'Konsinyasi', value: 'consignment' },
  { label: 'Pembayaran Bertahap', value: 'installment-payment' },
  { label: 'Sistem Kredit Usaha', value: 'business-credit-system' },
  { label: 'Trade Financing', value: 'trade-financing' },
  { label: 'Lainnya', value: 'others' }
]
export const transactionTypeBuyerOptions = [
  { label: 'Perusahaan (Akuisisi Sepenuhnya)', value: 'full-acquisition' },
  { label: 'Investment (Akuisisi Sebagian)', value: 'partial-acquisition' },
  { label: 'Partisipasi dari Manajemen (Investasi Sebagian)', value: 'management-participation' },
  { label: 'Pembiayaan (Peluang Pemberian Pinjaman)', value: 'financing-opportunity' },
  { label: 'Peluang Waralaba', value: 'franchise-opportunity' },
  { label: 'Peluang Penjualan (Agen / Reseller)', value: 'reseller-opportunity' },
  { label: 'Ide Bisnis (Peluang Perusahaan Baru)', value: 'business-idea' }
]
export const transactionTypeLoanOptions = [{ label: 'Jaminan', value: 'loan' }]
export const transactionTypeFranchiseOptions = [{ label: 'Waralaba', value: 'franchise' }]
export const transactionTypeBusinessIdeaOptions = [{ label: 'Ide Bisnis', value: 'business-idea' }]
export const transactionTypeSalesPartnershipOptions = [
  { label: 'Kesempatan Penjualan', value: 'sales-opportunity' }
]
export const transactionTypeCompanyOptions = [
  { label: 'Perusahaan (Penjualan Penuh)', value: 'company-full-sale' },
  { label: 'Investasi (Penjualan Sebagian)', value: 'investment-partial-sale' },
  { label: 'Pembelian Manajemen (Penjualan Sebagian)', value: 'management-buy-in-partial-sale' },
  {
    label: 'Lainnya',
    value: 'others'
  }
]
export const mergedAllTransactionTypeOptions = [
  ...transactionTypeBuyerOptions,
  { label: 'Pembelian Langsung', value: 'direct-purchase' },
  { label: 'Kontrak Jangka Panjang', value: 'long-term-contract' },
  { label: 'Konsinyasi', value: 'consignment' },
  { label: 'Pembayaran Bertahap', value: 'installment-payment' },
  { label: 'Sistem Kredit Usaha', value: 'business-credit-system' },
  { label: 'Trade Financing', value: 'trade-financing' },
  { label: 'Lainnya', value: 'others' },
  { label: 'Jaminan', value: 'loan' },
  { label: 'Waralaba', value: 'franchise' },
  { label: 'Ide Bisnis', value: 'business-idea' },
  { label: 'Kesempatan Penjualan', value: 'sales-opportunity' },
  { label: 'Perusahaan (Penjualan Penuh)', value: 'company-full-sale' },
  { label: 'Investasi (Penjualan Sebagian)', value: 'investment-partial-sale' },
  { label: 'Pembelian Manajemen (Penjualan Sebagian)', value: 'management-buy-in-partial-sale' }
]

export const customerTypeValue = [
  { label: 'B2C', value: 'b2c' },
  { label: 'B2B', value: 'b2b' },
  { label: 'B2C & B2B', value: 'b2c-b2b' }
]
export const packageRoleName = {
  ADVISOR: 'Advisor',
  SELLER: 'Penjual',
  BUYER: 'Pembeli'
}

export const userRoleValue = [
  { label: 'Business Owner', value: 'business-owner' },
  { label: 'Management', value: 'management' },
  { label: 'Advisor', value: 'advisor' }
]
export const userRoleValueLoan = [
  { label: 'Business Owner', value: 'business-owner' },
  { label: 'Management', value: 'management' },
  { label: 'Advisor', value: 'advisor' }
]
export const userRoleValueFranchise = [
  { label: 'Business Owner', value: 'business-owner' },
  { label: 'Management', value: 'management' },
  { label: 'Advisor', value: 'advisor' }
]
export const optionsReasonSeller = [
  {
    label: 'Saya ingin mengambil alih perusahaan untuk mengelolanya sendiri.',
    value: 'Saya ingin mengambil alih perusahaan untuk mengelolanya sendiri.'
  },
  {
    label:
      'Saya menghubungi Anda karena ada klien yang menunjukkan ketertarikan pada penawaran ini.',
    value:
      'Saya menghubungi Anda karena ada klien yang menunjukkan ketertarikan pada penawaran ini.'
  },
  {
    label:
      'Saya ingin membeli saham di perusahaan ini untuk menjadi mitra yang berpartisipasi aktif.',
    value:
      'Saya ingin membeli saham di perusahaan ini untuk menjadi mitra yang berpartisipasi aktif.'
  },
  {
    label: 'Saya ingin membeli saham di perusahaan ini untuk berinvestasi/memberikan modal.',
    value: 'Saya ingin membeli saham di perusahaan ini untuk berinvestasi/memberikan modal.'
  },
  {
    label: 'Lainnya',
    value: 'lainnya'
  }
]
export const optionsReasonBuyer = [
  {
    label:
      'Saya akan menghubungi Anda karena saya memiliki perusahaan menarik yang sesuai dengan kriteria Anda.',
    value:
      'Saya akan menghubungi Anda karena saya memiliki perusahaan menarik yang sesuai dengan kriteria Anda.'
  },
  {
    label:
      'Saya memiliki perusahaan menarik dalam portofolio saya yang cocok dengan kriteria Anda.',
    value: 'Saya memiliki perusahaan menarik dalam portofolio saya yang cocok dengan kriteria Anda.'
  },
  {
    label:
      'Saya memiliki perusahaan dan ingin melakukan merger / diakuisisi untuk terus berkembang.',
    value:
      'Saya memiliki perusahaan dan ingin melakukan merger / diakuisisi untuk terus berkembang.'
  },
  {
    label: 'Lainnya',
    value: 'lainnya'
  }
]
export const spesialization = [
  {
    label: 'Akuntansi',
    value: '1'
  },
  {
    label: 'Perantara Bisnis',
    value: '2'
  },
  {
    label: 'Konsultasi M&A',
    value: '3'
  },
  {
    label: 'Konsultasi Keuangan',
    value: '4'
  },
  {
    label: 'Konsultasi Finansial',
    value: '5'
  },
  {
    label: 'Konsultasi Hukum',
    value: '6'
  },
  {
    label: 'Konsultasi Valuasi',
    value: '7'
  },
  {
    label: 'Bank',
    value: '8'
  },
  {
    label: 'Dana Ekuitas Privat',
    value: '9'
  }
]

export const groupPackageNamebyTypePackage = {
  LOAN: 'Pinjaman',
  BUSINESS_IDEA: 'Ide Bisnis',
  SALES_PARTNERSHIP: 'Kemitraan Penjualan',
  FRANCHISE: 'Waralaba',
  COMPANY: 'Perusahaan'
}

// Key dokumen legal pada payload `legal_files`; sama untuk akun personal & perusahaan
export const legalFileKeys = ['nib', 'npwp', 'ktp', 'sk_kemenkumham']

export const sellerCategoryData = [
  {
    label: 'Perusahaan',
    value: 'company'
  },
  // {
  //   label: 'Pinjaman',
  //   value: 'loan'
  // },
  {
    label: 'Waralaba',
    value: 'franchise'
  },
  {
    label: 'Kemitraan Penjualan',
    value: 'sales_partnership'
  }
  // {
  //   label: 'Ide Bisnis',
  //   value: 'business_idea'
  // }
]

export const xenditBankList = [
  // {
  //   label: 'BCA Virtual Account',
  //   value: 'BCA',
  //   value2: 'BCA_VIRTUAL_ACCOUNT',
  //   image: BCA_VA
  // },
  {
    label: 'BJB Virtual Account',
    value: 'BJB',
    value2: 'BJB_VIRTUAL_ACCOUNT',
    image: BJB_VA
  },
  {
    label: 'BNI Virtual Account',
    value: 'BNI',
    value2: 'BNI_VIRTUAL_ACCOUNT',
    image: BNI_VA
  },
  {
    label: 'BRIVA',
    value: 'BRI',
    value2: 'BRI_VIRTUAL_ACCOUNT',
    image: BRI_VA
  },
  //   {
  //     label: 'BSI Virtual Account',
  //     value: 'BSI',
  //     value2: 'BSI_VIRTUAL_ACCOUNT',
  //     image: BSI_VA
  //   },
  // {
  //   label: 'BSS Virtual Account',
  //   value: 'SAHABAT_SAMPOERNA',
  //   value2: 'SAHABAT_SAMPOERNA',
  //   image: BSS_VA
  // },
  {
    label: 'CIMB Virtual Account',
    value: 'CIMB',
    value2: 'CIMB_VIRTUAL_ACCOUNT',
    image: CIMB_VA
  },
  {
    label: 'Mandiri Virtual Account',
    value: 'MANDIRI',
    value2: 'MANDIRI_VIRTUAL_ACCOUNT',
    image: MANDIRI_VA
  },
  {
    label: 'Permata Virtual Account',
    value: 'PERMATA',
    value2: 'PERMATA_VIRTUAL_ACCOUNT',
    image: PERMATA_VA
  }
]

export const transactionBadgeValue = {
  PAID: {
    badgeType: 'success-badge',
    class: 'text-success w-fit text-nowrap',
    label: 'Dibayar'
  },
  UNPAID: {
    badgeType: 'warning-badge',
    class: 'text-surface-warning-dark w-fit text-nowrap',
    label: 'Belum Dibayar'
  },
  EXPIRED: {
    badgeType: 'danger-badge',
    class: 'text-button-danger w-fit text-nowrap',
    label: 'Expired'
  }
}

export const companyLineOptions = [
  {
    label: 'Teknologi & TI',
    ebitda_multiple: 12.5,
    value: 'technology-it'
  },
  {
    label: 'Kesehatan',
    ebitda_multiple: 10,
    value: 'healthcare'
  },
  {
    label: 'Barang Konsumsi (FMCG)',
    ebitda_multiple: 12,
    value: 'consumer-goods'
  },
  {
    label: 'Jasa Keuangan',
    ebitda_multiple: 8,
    value: 'financial-services'
  },
  {
    label: 'Periklanan & Pemasaran',
    ebitda_multiple: 10,
    value: 'advertising-marketing'
  },
  {
    label: 'Otomotif',
    ebitda_multiple: 5.5,
    value: 'automotive'
  },
  {
    label: 'Perhotelan & Pariwisata',
    ebitda_multiple: 8,
    value: 'hospitality-tourism'
  },
  {
    label: 'Logistik & Transportasi',
    ebitda_multiple: 7,
    value: 'logistics-transportation'
  }
]

export const rejectReason = [
  {
    value:
      'Kami sudah bekerja sama dengan pihak lain yang sesuai, sehingga belum membuka peluang baru saat ini.',
    label:
      'Kami sudah bekerja sama dengan pihak lain yang sesuai, sehingga belum membuka peluang baru saat ini.'
  },
  {
    value:
      'Terima kasih atas ketertarikannya, namun profil Anda belum sesuai dengan kebutuhan bisnis kami saat ini.',
    label:
      'Terima kasih atas ketertarikannya, namun profil Anda belum sesuai dengan kebutuhan bisnis kami saat ini.'
  },
  {
    value:
      'Sayangnya, bidang usaha Anda belum relevan dengan arah atau fokus bisnis kami saat ini.',
    label: 'Sayangnya, bidang usaha Anda belum relevan dengan arah atau fokus bisnis kami saat ini.'
  },
  { value: 'Lainnya', label: 'Lainnya' }
]
